import React, { Children } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// ====

const Modal = (props) => {
  const { children, className, closeFunction, size } = props;

  // ====

  return (
    <div className="brand-modal">
      <div
        className="brand-modal-screen brand-modal-background"
        onClick={closeFunction}
      />
      <div
        className={`brand-modal-window ${
          size && `brand-modal-window-${size}`
        } ${className && className}`}
      >
        {children}
      </div>
      <div
        className="brand-modal-controls pt-2 pr-4 pl-4 brand-text-white brand-font-size-2"
        onClick={closeFunction}
      >
        <FontAwesomeIcon icon="times" className="brand-cursor-pointer" />
      </div>
    </div>
  );
};

export default Modal;

// ====

Modal.propTypes = {
  className: PropTypes.string,
  size: PropTypes.string,
};

Modal.defaultProps = {
  align: 'center',
  className: '',
  size: 'auto',
};
